import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-more',
  templateUrl: './icon-more.component.html',
  styleUrls: ['./icon-more.component.scss']
})
export class IconMoreComponent implements OnInit {
  @Input() color: string = '#262628';
  @Input() size: number = 18;

  constructor() { }

  ngOnInit() {
  }

}
